export const COVERAGE_OPTIONS = [
  { label: 'Ensemble de la zone couverte par la plateforme', code: 1 },
  { label: 'Territoire de compétence de l\'organisation', code: 2 },
  { label: 'Calculée sur la donnée', code: 0 }
];

export const MAPS_GEOMETRY_TYPES_MAPPING = {
  0: 'indéfini',
  1: 'point',
  2: 'ligne',
  3: 'polygone'
};

export const DEFAULT_MAPS_CONTEXT = {
  version: 1,
  parameters: [],
  coords:[-1.34686,45.05679],
  zoom: 7.7,
  projection: 'EPSG:3857',
  layers: [
    {
      visible: true,
      title: 'Fond cartographique',
      childs: [
        {
          layername: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2',
          title: 'Plan IGN',
          type: 'WMTS',
          visible: true,
          useSldBody: false,
          dataviz: {
            url: '',
            active: false,
            activePopup: false
          },
          editable: false,
          queryable: true,
          idProperty: '',
          layerIndex: 0,
          boundingBoxEPSG4326: [
            -175,
            -85,
            175,
            85
          ],
          getFeatureInfoFormat: 'application/json',
          url: 'https://wxs.ign.fr/cartes/geoportail/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetCapabilities',
          baseLayer: true,
          opacity: 1,
          isLegendDisplayed: true,
          legendImageUrl: null,
          description: 'Cartographie multi-échelles sur le territoire national, issue des bases de données vecteur de l’IGN, mis à jour régulièrement et réalisée selon un processus entièrement automatisé.',
          popupInfos: {
            active: false,
            edited: false
          },
          style: {
            fillStyle: {
              fillSymbol: {},
              fillPattern: 'simple'
            },
            strokeStyle: {
              symbol: {},
              pattern: 'simple'
            },
            pointSymbol: {},
            textStyle: {
              text: ''
            }
          },
          complexStyle: {
            styleRules: []
          },
          Attribution: {
            Title: '© IGN',
            OnlineResource: 'https://www.ign.fr'
          },
          metadataUrl: 'https://geoservices.ign.fr/planign',
          ignoreUrlInCapabiltiesResponse: false,
          layerProperties: []
        }
      ]
    }
  ],
  plugins: [
    {
      plugin: 'navigation',
      configuration: {
        isActive: false
      },
      parameters: []
    },
    {
      plugin: 'layerList',
      configuration: {
        isActive: true
      },
      parameters: []
    },
    {
      plugin: 'print',
      configuration: {
        isActive: false
      },
      parameters: []
    },
    {
      plugin: 'measure',
      configuration: {
        isActive: false
      },
      parameters: []
    },{
      plugin: 'recherche-lieux',
      configuration: {
        isActive: false
      },
      parameters: []
    },
    {
      plugin: 'coordonnes',
      configuration: {
        isActive: false
      },
      parameters: []
    },
    {
      plugin: 'permalink',
      configuration: {
        isActive: false
      },
      parameters: []
    },
    {
      plugin: 'loading-infos',
      configuration: {
        isActive: false
      },
      parameters: []
    },
    {
      plugin: 'legend',
      configuration: {
        isActive: false
      },
      parameters: []
    },
    {
      plugin: 'swipe',
      configuration: {
        isActive: false
      },
      parameters: []
    },
     {
      plugin: 'annotation',
      configuration: {
        isActive: false
      },
      parameters: []
    },
    {
      plugin: 'feature-infos',
      configuration: {
        isActive: false
      },
      parameters: []
    }
  ]
};
